<template>
  <div id="page-wrap">
    <div class="container">
      <div class="tab-content" id="myTabContent">
        <CloudDisk></CloudDisk>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DiskWraper",
  components: {
    CloudDisk: () => import("./CloudDisk"),
  },
  created() {
    this.$store.commit("SET_THEME", "云盘");
  },
};
</script>